import { createContext, useContext, useState } from "react";
import { useMutation } from "@apollo/client";
import { gql } from "@apollo/client";

export const NotificationPermissionContext = createContext(null);

export default function NotificationPermissionProvider({children}) {
    const [notificationsEnabled, setNotificationsEnabled] = useState(Notification.permission === 'granted');
  
    const [subscribeToPushMutation] = useMutation(gql`
      mutation SubscribeToPush($subscription: PushSubscriptionInput!) {
        subscribeToPush(subscription: $subscription)
      }
    `);
  
    async function subscribeToPush() {
      const registration = await navigator.serviceWorker.ready;
      const subscription = await registration.pushManager.subscribe({
        userVisibleOnly: true,
        // TODO: get this from the server
        applicationServerKey: urlBase64ToUint8Array('BDMjP6km5Uy53O_69yLPR3Wg6qTx_sTYuGhCRbtagCVaXIXULfaOXouSUCYUuIGI080he0VDMbE3PdHh2lbtD8E')
      });
      
      console.log('Raw subscription:', JSON.stringify(subscription, null, 2));
  
      const subscriptionObject = subscription.toJSON();
  
      const subscriptionInput = {
        endpoint: subscription.endpoint,
        keys: {
          p256dh: subscriptionObject.keys.p256dh,
          auth: subscriptionObject.keys.auth
        }
      };
  
      console.log('Subscription input:', JSON.stringify(subscriptionInput, null, 2));
  
      const { data } = await subscribeToPushMutation({ variables: { subscription: subscriptionInput }});
      console.log(data);
    }
  
    // Helper function to convert VAPID key
    function urlBase64ToUint8Array(base64String) {
      const padding = '='.repeat((4 - base64String.length % 4) % 4);
      const base64 = (base64String + padding).replace(/-/g, '+').replace(/_/g, '/');
      const rawData = window.atob(base64);
      const outputArray = new Uint8Array(rawData.length);
      for (let i = 0; i < rawData.length; ++i) {
        outputArray[i] = rawData.charCodeAt(i);
      }
      return outputArray;
    }
  
    const toggleNotifications = () => {
      console.log('toggleNotifications');
      if (Notification.permission === 'default') {
        console.log('requesting permission');
        Notification.requestPermission().then(permission => {
          setNotificationsEnabled(permission === 'granted');
          if (permission === 'granted') {
            subscribeToPush();
          }
        });
      } else {
        console.log('permission is not default');
        setNotificationsEnabled(Notification.permission === 'granted');
      }
    };

    return (
        <NotificationPermissionContext.Provider value={{notificationsEnabled, toggleNotifications}}>
            {children}
        </NotificationPermissionContext.Provider>
    )
}

export function useNotificationPermission() {
    return useContext(NotificationPermissionContext);
}